module.exports = __webpack_public_path__ + "static/media/loading_alt.8c84b70d.gif";